import { Radio, Space } from 'antd';
import React, { ReactElement } from 'react';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';

const FormRadioButton =
  (props: any): (ReactElement | null) => {
    const formConfig = useGetFormConfig(props);
    const { disabled, onChange, options, key, direction, starRadio, className } = formConfig;

    const getOptions = (): any => {
      return options.map((option: any, index: number): ReactElement => {
        return <Radio value={option?.value} key={option?.value} disabled={option?.disabled ? option?.disabled : false}
        className = {index === 1 && starRadio ? className : ''}
        data-testid={`${key}-${option?.value}`}> {option?.name} </Radio>;
      });
    };

    return <FormItem formConfig={formConfig}>
      <Radio.Group disabled={disabled} onChange={onChange} data-testid={key}>
        {
          direction ?
            <Space direction={direction} className="crm-element-radio">
              {getOptions()}
            </Space> :
            getOptions()
        }
      </Radio.Group>
    </FormItem>;
  };

export default FormRadioButton;
